import { c as _c } from "react/compiler-runtime";
import { BillingPeriodEnum } from 'modules/profile/user-plan/enums/billing-period-enum';
import { tableFeatures, UseUserPlanInterface } from 'modules/profile/user-plan/types/user-plan-interface';
import { isFeatureExceeded } from 'modules/profile/user-plan/utils/price-plan-utils';
import React from 'react';
import { CheckBoxSwitcher } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
export interface PricePlanFeaturesColumnProps {
  billingPeriod: BillingPeriodEnum;
  setBillingPeriod: React.Dispatch<React.SetStateAction<BillingPeriodEnum>>;
  data: UseUserPlanInterface;
}
const PricePlanFeaturesColumn = t0 => {
  const $ = _c(23);
  const {
    billingPeriod,
    setBillingPeriod,
    data
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.settings.user_plan.billing_period_title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <b className="text-text-primary text-start text-lg">{t1}</b>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = billingPeriod === BillingPeriodEnum.annual;
  let t4;
  if ($[4] !== setBillingPeriod) {
    t4 = () => setBillingPeriod(_temp);
    $[4] = setBillingPeriod;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("dashboard.settings.user_plan.billing_period_label");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <span className="min-w-[90px]">{t5}</span>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t6) {
    t7 = <CheckBoxSwitcher selected={t3} onChange={t4} label={t6} />;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t2 || $[15] !== t7) {
    t8 = <div className="mb-6 h-[150px]"><div className="flex h-[150px] flex-col gap-[23px] pt-2 pr-1 pl-4">{t2}{t7}</div></div>;
    $[14] = t2;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== data || $[18] !== t) {
    t9 = tableFeatures.map((column, index) => {
      const isExceeded = isFeatureExceeded(data, column);
      return <React.Fragment key={`features-column-${column.key}`}><div className={twMerge("text-text-primary truncate px-4 text-left text-base font-medium", isExceeded && "text-text-error")}>{t(column.title)}</div>{tableFeatures[index + 1] ? <hr className="border-border-200 desktop:-mr-6 mr-0 border-solid" /> : <div />}</React.Fragment>;
    });
    $[17] = data;
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = <div className="bg-bg-accent-light desktop:my-[1px] desktop:grid desktop:w-full my-[0.5px] flex w-1/2 flex-col gap-2 pt-10">{t8}{t9}</div>;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};
export default PricePlanFeaturesColumn;
function _temp(prev) {
  if (prev === BillingPeriodEnum.monthly) {
    return BillingPeriodEnum.annual;
  }
  return BillingPeriodEnum.monthly;
}